import React, { Component } from 'react'
import { RouteComponentProps } from "react-router-dom";
import { Menu, Icon, Button } from "antd";
import  Layout from "antd/es/layout";
// css
import './style.less'
// img
import DefaultImg from '@/assets/image/defaultHead.svg'

const {  Sider } = Layout;
const { SubMenu } = Menu;
interface iProps  { 
    onChange?: (collapsed) => void;
    goto: (collapsed) => void;
    collapsed?: boolean;
    menuData: any[]
    menuSelectKeys: any[],
    user: any
}

interface iState {
    collapsed: boolean;
    selectedKeys: string[],
    menuData:any[]
}
export class CollapsedMenu extends Component<iProps, iState> {
    state: iState = {
        collapsed: true,
        selectedKeys: [],
        menuData:[
            {
                "entry": null,
                "functionId": "1",
                "icon": "https://bs-application-resource.oss-cn-beijing.aliyuncs.com/pc/icon/lecoCenter/menu/index.svg",
                "name": "首页",
                "shortName": "首页",
                "subFunctionItems": null,
                "type": "route",
                "url": "/fitness-home/?system_partition_gId=1"
            },
            {
                "entry": null,
                "functionId": "2",
                "icon": "https://bs-application-resource.oss-cn-beijing.aliyuncs.com/pc/icon/lecoCenter/menu/index.svg",
                "name": "我的小组",
                "shortName": "我的小组",
                "subFunctionItems": null,
                "type": "route",
                "url": "/fitness-team/?system_partition_gId=1"
            }
        ]
    };
    onCollapse = () => {
        this.setState({ collapsed: !this.state.collapsed },() => {
            this.props.onChange(this.state.collapsed)
        });
    };
    getMenu = (functionItems): JSX.Element[] => {
        let list: Array<JSX.Element> = [];
        list = functionItems.map((functionItem, index: number) =>
        functionItem.subFunctionItems && functionItem.subFunctionItems.length ? (
            <SubMenu
                key={functionItem.functionId}
                title={
                    <span className={this.state.collapsed ? 'subNemu subNemu-collapsed' : 'subNemu'}>
                    {functionItem.icon &&<span className="icon">
                        <img src={functionItem.icon} alt=""/>
                    </span>}
                  

                    <span className="text">{functionItem.name}</span>
                    </span>
                }
            >
                {this.getMenu(functionItem.subFunctionItems)}
            </SubMenu>
            ) : (
            <Menu.Item key={functionItem.url}>
                <span className={this.state.collapsed ? 'subNemu subNemu-collapsed' : 'subNemu'}>
                    {functionItem.icon &&
                    <span className="icon">
                    <img  src={functionItem.icon } alt=""/>
                    </span>}

                    {/* <span className='icon'>
                    <img src='https://bs-application-resource.oss-cn-beijing.aliyuncs.com/pc/icon/lecoCenter/menu/index.svg' alt=""/>

                    </span> */}

                    <span className="text">{functionItem.shortName || functionItem.name}</span>
                </span>
            </Menu.Item>
            )
        );
        return list;
    };
    goto = value => {
        console.log(value)
        this.props.goto(value)
    };
    render() {
        const { 
            collapsed,
            selectedKeys
        } = this.state;
        const {user} = this.props
        return (
            <>
                <div className="toggleMenuBtn" onClick={this.onCollapse}  style={{left: collapsed ? '64px': '180px'}}>
                    <Icon type={collapsed ? 'caret-right' : 'caret-left'} />
                </div>
                <Sider
                    collapsedWidth={64}
                    className="site-layout-background"
                    style={{
                        overflowX: "hidden",
                        overflowY: "auto",
                        height: "calc(100vh - 64px)",
                        position: "fixed",
                        left: 0,
                        width: collapsed ? '64px': '180px'
                    }}
                    collapsed={collapsed}
                >
                    <div className={collapsed ? 'CollapsedMenu': 'CollapsedMenu notCollapse'}>
                        {
                            this.props.menuData ? (
                                <Menu
                                    mode="inline"
                                    style={{height:'100%'}}
                                    inlineCollapsed={collapsed}
                                    inlineIndent={15}
                                    onClick={this.goto}
                                    selectedKeys={this.props.menuSelectKeys}
                                    >
                                      
                                    {this.getMenu(this.props.menuData)}
                                </Menu>
                            ): ''
                        }
                    </div>
                </Sider>
            </>
        )
    }
}

